<div class="modal-container">
    <div class="modal-top-bar">
        <b>MIB explorer: {{data.file}}</b>
    </div>
    <div class="modal-content">
        <div class="mib-module" *ngFor="let module of data.mib.modules">
            <div class="module-title">
                <span>Name: {{module.name}}</span>
            </div>
            <table>
              <th></th>
                <tr class="mib-object" *ngFor="let object of module.objects">
                    <td class="checkbox">
                        <mat-checkbox [disabled]="isConfigured(object)" [checked]="isSelected(object)"
                            (change)="objectSelectionChanged(object)"></mat-checkbox>
                    </td>
                    <td class="mib-object-field">{{object.name}}</td>
                    <td class="mib-object-field">{{object.oid}}</td>
                </tr>
            </table>
        </div>
    </div>
    <div class="modal-bottom-bar">
        <button class="button mini wide outline" (click)="cancel()">Cancel</button>
        <button class="button mini wide" (click)="save()">Save</button>
    </div>
</div>
